var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-select',{attrs:{"value":_vm.value.pageNo,"items":_vm.items},on:{"input":function($event){return _vm.$emit('input', $event)}}},[_c('template',{slot:"append-outer"},[_c('span',{staticClass:"total pt-2"},[_vm._v("/ "+_vm._s(_vm.value.count)+"件")])])],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }